import { useAppSelector } from '../../../reducers';
import { isUngatedForInbound25Selector } from '../../../selectors/GatingSelectors';
import { MerchCardColumns } from 'pricing-pages-ui-components/components/MerchCardShadowColumns';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const MobileCardWrapper = ({
  children
}) => {
  const isUngatedForInbound = useAppSelector(isUngatedForInbound25Selector);
  if (isUngatedForInbound) {
    return /*#__PURE__*/_jsx(MerchCardColumns, {
      columns: 1,
      maxInlineSize: "initial",
      marginBlockStart: "500",
      children: children
    });
  }
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "500",
    inlineSize: "100%",
    children: children
  });
};
export default MobileCardWrapper;